export default class CodebookValueNotFoundError extends Error {
  constructor(codebookName: string, id: number | string) {
    super(`${codebookName}: ${id} not found`)

    this.name = 'CodebookValueNotFound'
  }
}
